<template>
<div class="custom-modal-wrap overflow-y-auto  overflow-x-hidden fixed top-0 right-0 left-0 z-[100] md:inset-0 h-modal md:h-full justify-center items-center flex">
    <div class="absolute top-[30px] left-0 flex justify-center items-center  my-0 mx-auto right-0 w-full z-10 text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
       <div class="transition-width duration-500 w-[1004px] mx-auto mt-10 pt-3 bg-light-black px-[16px] py-[16px] rounded-lg">
            <table class="table-auto w-full h-full">
                <thead>
                    <tr>
                        <th class="p-4 text-left">Name</th>
                        <th class="p-4 text-left">Variant</th>
                        <th class="p-4 text-left w-[150px]">Category</th>
                        <th class="p-4 text-left w-[150px]">Brand</th>
                        <th class="p-4 text-left">SKU</th>
                        <th class="p-4 text-left">GTIN</th>
                    </tr>
                </thead>
                <tbody >
                    <tr class="row h-30 transition duration-500 border-y border-gray-black" >
                        <td class="p-4 text-theme-green">{{ product.name }}</td>
                        <td class="p-4">{{ product.variantName }}</td>
                        <td class="p-4">{{ product.category?.name }}</td>
                        <td class="p-4">{{ product.brand?.name }}</td>
                        <td class="p-4">{{ product.sku }}</td>
                        <td class="p-4">{{ product.barcode }}</td>
                    </tr>
                    <tr>
                        <td colspan="6">
                            <div class="flex flex-col gap-5 pt-5">
                                <div @click="toggle(lot)" v-for="(lot, ind) in lotList" :key="ind" class="flex flex-row items-center gap-5 drop-shadow transition duration-500 cursor-pointer">
                                    <div>
                                        <svg v-if="isSelected(lot)" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.45 17.55C0.75 17.85 1.1 18 1.5 18H16.5C16.9 18 17.25 17.85 17.55 17.55C17.85 17.25 18 16.9 18 16.5V1.5C18 1.1 17.85 0.75 17.55 0.45C17.25 0.15 16.9 0 16.5 0H1.5C1.1 0 0.75 0.15 0.45 0.45C0.15 0.75 0 1.1 0 1.5V16.5C0 16.9 0.15 17.25 0.45 17.55ZM16.5 16.5H1.5V1.5H16.5V16.5Z" fill="#2BA66B"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 16.5H16.5V1.5H1.5V16.5ZM14.7 5.75L7.475 12.975L3.425 8.925L4.5 7.85L7.475 10.825L13.625 4.675L14.7 5.75Z" fill="#2BA66B"/>
                                            <path d="M7.475 12.975L14.7 5.75L13.625 4.675L7.475 10.825L4.5 7.85L3.425 8.925L7.475 12.975Z" fill="white"/>
                                        </svg>
                                        <svg v-else width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.5 18C1.1 18 0.75 17.85 0.45 17.55C0.15 17.25 0 16.9 0 16.5V1.5C0 1.1 0.15 0.75 0.45 0.45C0.75 0.15 1.1 0 1.5 0H16.5C16.9 0 17.25 0.15 17.55 0.45C17.85 0.75 18 1.1 18 1.5V16.5C18 16.9 17.85 17.25 17.55 17.55C17.25 17.85 16.9 18 16.5 18H1.5ZM1.5 16.5H16.5V1.5H1.5V16.5Z" fill="white"/>
                                        </svg>
                                    </div>
                                    <div class="flex-start">Lot # {{ lot.batch_lot }}</div>
                                </div>

                                <!-- add new -->
                                <div class="flex w-full mb-5">
                                    <div v-if="addNew" class="w-full self-stretch inline-flex flex-col justify-start items-start gap-0.5">
                                        <div class="self-stretch px-4 rounded outline outline-1 outline-offset-[-1px] inline-flex justify-start items-center" :class="newError?'outline-red-500':'outline-green-500'">
                                            <div class="flex-1 justify-center text-white text-sm font-normal font-['Roboto'] leading-4 line-clamp-1">
                                                <input v-model="newBatchLot" @keydown="resetError()" type="text" class="flex bg-transparent border-transparent focus:border-transparent w-full" />
                                            </div>
                                            <button @click="addLot" :disabled="newError || !newBatchLot" class="h-10 py-2 flex justify-center items-center gap-2">
                                                <div class="w-6 h-5 relative overflow-hidden">
                                                    <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg" :class="newError || !newBatchLot ? 'fill-grey':'fill-green-500'">
                                                        <path d="M20 0H2C0.9 0 0 0.9 0 2V5.99H2V1.98H20V16.01H2V11.99H0V16C0 17.1 0.9 17.98 2 17.98H20C21.1 17.98 22 17.1 22 16V2C22 0.89 21.1 0 20 0ZM10 12.99L14 8.99L10 4.99V7.99H0V9.99H10V12.99ZM20 0H2C0.9 0 0 0.9 0 2V5.99H2V1.98H20V16.01H2V11.99H0V16C0 17.1 0.9 17.98 2 17.98H20C21.1 17.98 22 17.1 22 16V2C22 0.89 21.1 0 20 0ZM10 12.99L14 8.99L10 4.99V7.99H0V9.99H10V12.99Z"/>
                                                    </svg>
                                                </div>
                                                <div class="text-center justify-start text-base font-normal font-['Roboto'] leading-5 line-clamp-1" :class="newError || !newBatchLot ? 'text-grey':'text-green-500'">Enter</div>
                                            </button>
                                        </div>
                                        <div class="justify-center text-red-500 text-xs font-normal font-['Roboto'] leading-4">{{ errorMsg }}</div>
                                    </div>
                                    <div v-else class="w-full self-stretch pr-2 inline-flex justify-start items-center">
                                        <div @click="addNew=true" data-color="Green" data-error="No" data-fill="No" data-show-l-icon="true" class="h-10 py-2 rounded-md border-green-500 flex justify-center items-center gap-2 cursor-pointer hover:opacity-80">
                                            <div class="w-6 h-6 relative">
                                                <svg class="w-5 h-5 top-[2px] absolute fill-green-500"  width="32" height="32" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"></path>
                                                </svg>
                                            </div>
                                            <div class="text-center justify-start text-green-500 text-base font-normal font-['Roboto'] leading-5 line-clamp-1">Create New Lot</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>

                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="4"></td>
                        <td colspan="2" class="text-right">
                            <button class="border border-grey hover:border-grey/60 text-grey px-3 py-2 w-[100px] rounded mr-5 uppercase" @click="$emit('close')">Cancel</button>
                            <button class="bg-theme-green hover:bg-theme-green/70 disabled:bg-theme-grey text-white px-3 py-2 w-[100px] rounded uppercase" :disabled="selectedLots.length==0" @click="$emit('add', product, selectedLots)">Add</button>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div> 
</div> 
</template>
<script>
import { ref, defineComponent } from 'vue'
import { mapGetters, mapMutations} from "vuex";
import { useSnackbar } from "vue3-snackbar"
import Helpers from '@/helpers';
import ProductHelper from '@/helpers/product'
import ProductApi from '@/controllers/BusinessProductApis'

export default defineComponent({
    props: ['product'],
    setup() {
        const snackbar = useSnackbar();
        const lotList = ref([])
        const selectedLots = ref([])
        const addNew = ref(false)
        const newBatchLot = ref('')
        const newError = ref(false)
        const errorMsg = ref('')
        return {snackbar, lotList, selectedLots, addNew, newBatchLot, newError, errorMsg}
    },
    mounted(){
        this.lotList = this.product.batchUploadDetails
    },
    computed: {
        ...mapGetters({
            vg_selectedLocation: 'location/selected'
        })
    },
    methods: {
        isSelected(lot){
            return this.selectedLots.find(selectedLot => selectedLot.id===lot.id)
        },
        toggle(lot){
            let findIndex = this.selectedLots.findIndex(selectedLot => selectedLot.id===lot.id)
            if(findIndex>=0){
                this.selectedLots.splice(findIndex, 1)
            }else{
                this.selectedLots.push(lot)
            }
            this.$emit('change', this.selectedLots)
        },
        resetError(){
            this.newError = false
            this.errorMsg = ""
        },
        async fetchLots(){
            let lotParams = {
                "locationId": this.vg_selectedLocation.id,
                "productId": this.product.id,
            }
            let res = await ProductApi.fetchLotByProductId(lotParams)
            if(res.data?.payload?.batchUploadDetails){
                this.lotList = res.data.payload.batchUploadDetails
            }
        },
        async addLot(){
            this.vm_spinner(true)
            let obj  = ProductHelper.getDataForNewBatchApi({
                locationId: this.vg_selectedLocation.id, 
                productId: this.product.id, 
                batch_lot: this.newBatchLot
            })
            let res = await ProductApi.createProductBatch(obj)
            if(res.status==201){
                this.snackbar.add({
                    type: 'info',
                    text: "Lot created successfully.",
                    duration: 3000,
                })
                this.newBatchLot = ''
                this.addNew = false
                await this.fetchLots()
            }else{
                this.newError = true
                this.errorMsg = Helpers.catchErrorMessage(res.response.data)
            }
            this.vm_spinner(false)
        },
        ...mapMutations({
            vm_spinner: 'spinner/mutateSpinner'
        })
    }
})
</script>
<style>
.custom-modal-wrap:before {
  content: '';
  position: fixed;
  top: 0;
  width: 0;
  height: 100%;
  width: 100%;
  background: rgb(0 0 0 / 64%);
}
</style>